export const deleteDocumentHistoryService =
  (fetch) =>
  async (idHistorial, historyType = "institucional") => {
    try {
      const url =
        historyType === "safeCars"
          ? `/api/v2/delete/documentos/vehiculos/seguros/historial/${idHistorial}`
          : `/api/v2/delete/documentos/compania/historial/${idHistorial}`;

      const response = await fetch({
        url,
        method: "delete",
        permission: "1",
      });
      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
